import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-svgbar',
    templateUrl: './svgbar.component.html',
    styleUrls: ['./svgbar.component.scss'],
    standalone: false
})
export class SvgbarComponent {
  _value = 0;
  _max = 0;
  relVal = 0;
  @Input() set value(value: number) {
    this._value = value;
    this.relVal = this._max ? (this._value / this._max) * 100 : 0;
  }
  @Input() set max(value: number) {
    this._max = value;
    this.relVal = this._max ? (this._value / this._max) * 100 : 0;
  }
}
